export const CREATE_VENDOR83788 = "CREATE_VENDOR83788";
export const UPDATE_VENDOR83788 = "UPDATE_VENDOR83788";
export const DELETE_VENDOR83788 = "DELETE_VENDOR83788";
export const FETCH_VENDOR83788 = "FETCH_VENDOR83788";
export const LISTEN_TO_SELECTED_VENDOR83788 = "LISTEN_TO_SELECTED_VENDOR83788";
export const FILTER_VENDOR83788 = "FILTER_VENDOR83788";
